// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ADtI","right":"Footer_right__1-aX5","buttons":"Footer_buttons__37tmy"};